<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div>
          <h5 class="vue-title pull-left custom-header">
            <strong>{{ $t("NOTIFICATION") }}一覧</strong>
          </h5>

          <p
            class="float-right btn-add-partner"
            v-if="checkPermisssion('NOTIFICATION_MENU', 'NOTIFICATION')"
          >
            {{ $t("ADD") }}
            <a href="#/addnotification">
              <em class="fas fa-plus-circle"></em>
            </a>
          </p>
          <b-input-group class="pull-right search-text-box">
            <template v-slot:prepend>
              <b-input-group-text @click="onSerach" autofocus>
                <em class="fa fa-search"></em>
              </b-input-group-text>
            </template>
            <b-form-input
              size="md"
              @keyup.enter="onSerach"
              autocomplete="off"
              v-model="searchKeyword"
              class="form-control form-control-md"
            ></b-form-input>
          </b-input-group>

          <b-input-group class="pull-right search-text-box custom-drop-down">
            <b-form-select
              v-model="selectedItem"
              :options="notificationSelectType"
              class="mb-3"
              value-field="id"
              text-field="name"
              v-on:change="getSelectedItem"
              disabled-field="notEnabled"
              placeholder="表示"
              default-value="all"
            ></b-form-select>
          </b-input-group>
        </div>

        <c-table
          :table-data="notificationList.list"
          :fields="tableHeaders"
          :per-page="10"
          striped
          hover
          :isBusy="isBusy"
          :sortTable="sortTable"
          :total="notificationList.pageTotal"
          :edit="edit"
          :delete="delet"
          :pagination="pagination"
        ></c-table>
        <nav>
          <div class="pagination-module">
            <b-pagination
              :total-rows="notificationList.pageTotal"
              @change="pagination"
              :per-page="10"
              v-model="currentPage"
              :prev-text="$t('FORWARD')"
              :next-text="$t('NEXT')"
            />
          </div>
        </nav>
        <b-modal id="modal-delete" hide-footer>
          <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
          <p class="my-2">
            {{ selectedItemForDelete.title }}
            {{ $t("DELETECONFIRMATIONCOMMOM") }}
          </p>
          <hr />
          <b-row>
            <b-col>
              <b-button
                variant="outline-danger"
                class="buttons-align-right"
                size="sm"
                @click="deleteTableRowData()"
                >{{ $t("DELETE") }}</b-button
              >

              <b-button
                variant="outline-secondary"
                size="sm"
                class="buttons-align-right"
                @click="$bvModal.hide('modal-delete')"
                >{{ $t("CANCEL") }}</b-button
              >
            </b-col>
          </b-row>
        </b-modal>
      </div>
      <br />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import cTable from "@/components/Table.vue";
import { checkPermisssion } from "@/shared/utils.js";
import {
  GET_NOTIFICATION_LIST,
  DELETE_NOTIFICATOIN
} from "@/store/actions.type";
export default {
  name: "notification-list",
  data() {
    return {
      checkPermisssion: checkPermisssion,
      isBusy: true,
      selectedItem: "",
      selectedItemForDelete: {},

      notificationSelectType: [
        { name: "選んでください", id: "" },
        { name: "すべて", id: "all" },
        { name: "提携先", id: "partner" },
        { name: "ユーザー", id: "user" }
      ],
      selectedDisplayOption: "すべて",
      tableHeaders: [],
      currentPage: 1
    };
  },
  components: { cTable },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    delet(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    edit(id) {
      this.$router.push({
        name: "editNotification",
        params: { id: id.id }
      });
    },

    /**
     * Filter on function on  table Date
     * Input @param {String} notify_type Type of the table date
     * Output @param {List}   response.list  Filtered List
     */
    async getSelectedItem(myarg) {
      this.selectedItem = myarg;
      let payload = {
        notify_type: myarg,
        page: 1,
        field: this.sortField,
        sort: this.sortDirection,
        search_query: this.searchKeyword
      };
      this.isBusy = true;
      await this.$store.dispatch(GET_NOTIFICATION_LIST, payload);
      this.isBusy = false;
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    },

    /* Pagintaion */
    pagination(page) {
      this.loadTableData(page);
    },
    /**
     * To load the table data
     * Input @param {page} currentPageCount the page number of data you want
     * Output {object} table data
     */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(GET_NOTIFICATION_LIST, {
        notify_type: this.selectedItem,
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },

    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      await this.$store.dispatch(GET_NOTIFICATION_LIST, {
        notify_type: this.selectedItem,
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },

    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {String}   data.status  Boolean status Api call
     */
    async deleteTableRowData() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      let response = await this.$store.dispatch(DELETE_NOTIFICATOIN, {
        id: this.selectedItemForDelete.id
      });
      this.isLoading.hide();

      if (_.get(response, "status", false)) {
        this.$toast.success({
          message: _.get(response, "message", "")
        });
        if (this.notificationList.list.length === 1) {
          this.pagination(1);
        } else {
          this.pagination(this.currentPage);
        }
      } else {
        this.$toast.error({
          message: _.get(response, "message", "")
        });
      }
      this.$bvModal.hide("modal-delete");
    }
  },
  computed: {
    ...mapGetters(["notificationList"])
  },
  created() {
    this.$store
      .dispatch(GET_NOTIFICATION_LIST, { field: "id", sort: "desc" })
      .then(data => {
        this.isBusy = false;
      });

    this.tableHeaders = [
      { key: "id", label: this.$t("ID"), sortable: true, class: "text-left" },
      {
        key: "title",
        label: this.$t("SUBJECT"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "message",
        label: this.$t("内容"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "notify_date_time",
        label: this.$t("通知日"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "notify_type",
        label: this.$t("対象者"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "created_by_user",
        label: this.$t("作成者"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "notify_status",
        label: this.$t("ステータス"),
        sortable: true,
        class: "text-left"
      }
    ];
    if (checkPermisssion("NOTIFICATION_MENU", "NOTIFICATION")) {
      // allowing users to do actions on table if they have Permission
      this.tableHeaders.push({
        key: "notification_actions",
        label: this.$t("アクション")
      });
    }
  }
};
</script>
<style>
.btn-add-partner {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
}

.search-text-box {
  width: 200px;
  margin: 10px 0px;
}
.custom-drop-down {
  width: 200px;
  margin: 10px 10px 00px 0px;
  margin-right: 10px;
}
</style>
